const HEX6 = /^[0-9a-fA-F]{6}$/;
const DEFAULT_PRIMARY = '#549ad3';
const DEFAULT_SECONDARY = '#cbddf0';
function readHexFromUrl(param, search = window.location.search) {
    const raw = new URLSearchParams(search).get(param)?.trim() ?? '';
    const v = raw.startsWith('#') ? raw.slice(1) : raw;
    return HEX6.test(v) ? `#${v}` : null;
}
export function applyThemeColorsFromUrl() {
    const primary = readHexFromUrl('primaryColor') ?? DEFAULT_PRIMARY;
    const secondary = readHexFromUrl('secondaryColor') ?? DEFAULT_SECONDARY;
    document.documentElement.style.setProperty('--primary-color', primary);
    document.documentElement.style.setProperty('--secondary-color', secondary);
}
